import * as React from 'react';
import { connect } from "react-redux";
import {AppActions, IState} from '../../types/types'
import FrontPage from './FrontPage'
import {  createTheme,  responsiveFontSizes,  ThemeProvider} from '@mui/material/styles';
import { lime, purple } from '@mui/material/colors';
import { GoBack, setContainersVisible } from '../../actions/folderViewActions';
import { ThunkDispatch } from 'redux-thunk';
import { currPathValue } from '../../types/enums';
import PdfFile from '../pdfViewer/pdfFile';

let theme = createTheme({
  palette: {
    primary: lime,
    secondary: purple,
  },
});
theme = responsiveFontSizes(theme);

export interface AppProps {
  currentPath: currPathValue;
  setContainersVisible: () => void;
  closePdfViewer: () => void;
}

export interface AppState {}

const FrontPageContainer = (props:AppProps)=> {
    React.useEffect(() => {
      props.setContainersVisible();
    }, []); // ✅ run once
    

    if(props.currentPath === currPathValue.PdfTron)
    {
      return <PdfFile handleClosePdfViewer={props.closePdfViewer}/>
    }

    return (  
            <ThemeProvider theme={theme}>
                <FrontPage/>
            </ThemeProvider>
    );
}

const mapStateToProps = (state:IState) => { return {
  currentPath: state.uiItems.currentPath
}}

const mapDispatchToProps = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {
  setContainersVisible: () => dispatch(setContainersVisible()),
  closePdfViewer: () => dispatch(GoBack())
})

export default connect(mapStateToProps, mapDispatchToProps)(FrontPageContainer);



